import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowLeft } from '@fortawesome/pro-solid-svg-icons'
import { useTranslation } from 'react-i18next'

import { BackButton, PageTitleHeader, Title } from './styled'

interface CourseFormPageTitleProps {
  title: string
  onBack: () => void
}

export const CourseFormPageTitle: React.FC<CourseFormPageTitleProps> = ({
  title,
  onBack,
}) => {
  const { t } = useTranslation()

  return (
    <PageTitleHeader>
      <BackButton
        type="button"
        onClick={onBack}
        aria-label={t('administration.lessons.buttons.back')}
      >
        <FontAwesomeIcon icon={faArrowLeft} aria-hidden />
      </BackButton>
      <Title>{title}</Title>
    </PageTitleHeader>
  )
}

export default CourseFormPageTitle
